/** @jsxImportSource @emotion/react */
import React, { FC, useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';

import supportMenuStyle from './support-menu.styles';
import PredefinedSwipableDrawer from '../swipable-edge-drawer/swipable-drawer.component';
import { useMediaQuery } from '@mui/material';
import supportIcon from '../../assets/icons/chat-icon.svg';
import { StationFooter } from '../../app/layouts/charge/components/footer/station-footer.component';
import { Z_INDEX } from '../../constants/zIndex';

export const SupportMenu: FC = props => {
    const isDesktop = useMediaQuery('(min-width:600px)');
    const intl = useIntl();
    const [supportSheetIsOpen, setSupportSheetIsOpen] = useState(false);

    const toggleLangList = () => {
        setSupportSheetIsOpen(prevState => {
            return !prevState;
        });
    };

    useEffect(() => {
        const overlayClickHandler = (e: MouseEvent) => {
            if (
                (supportSheetIsOpen && !(e.target instanceof Element)) ||
                !(e.target as Element).closest('#langMenuButton')
            ) {
                setSupportSheetIsOpen(false);
            }
        };

        document.addEventListener('click', overlayClickHandler);

        return () => {
            document.removeEventListener('click', overlayClickHandler);
        };
    }, []);

    const content = useMemo(() => {
        return (
            <>
                <p css={supportMenuStyle.header}>
                    {intl.formatMessage({ id: 'footer.info.title.support' })}
                </p>
                <StationFooter
                    shouldShowAboutTitle={false}
                    styles={supportMenuStyle.stationContainer}
                />
            </>
        );
    }, []);

    return (
        <div css={supportMenuStyle.container}>
            <button
                id="langMenuButton"
                css={[supportMenuStyle.buttonLang]}
                onClick={toggleLangList}>
                <img src={supportIcon} alt="support" />
            </button>
            {isDesktop ? (
                <>
                    {supportSheetIsOpen && (
                        <div css={[supportMenuStyle.langList, supportMenuStyle.langListDesktop]}>
                            {content}
                        </div>
                    )}
                </>
            ) : (
                <PredefinedSwipableDrawer
                    zIndex={Z_INDEX.DRAWER_SUPPORT}
                    onClose={() => setSupportSheetIsOpen(false)}
                    onOpen={() => setSupportSheetIsOpen(true)}
                    isOpen={supportSheetIsOpen}
                    snapPoints={[0.4]}>
                    <div css={supportMenuStyle.langList}>{content}</div>
                </PredefinedSwipableDrawer>
            )}
        </div>
    );
};
